import './AdBanner.css';

export function AdBanner() {
    return (
        <div className="ad-banner">
            <div className="ad-content">
                <p className="ad-label">Реклама</p>
                <div className="ad-placeholder">
                    <span>Ваша реклама здесь</span>
                    <small>728×90 баннер</small>
                </div>
            </div>
        </div>
    );
}
